import { Typography } from "@mui/material";
import applogo from "@public/logo_wo_bg.webp";
import Image from "next/legacy/image";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LangugageDropdown from "src/globalModule/components/languageDropdown";
import classes from "../../styles/navbar.module.css";
import RegistrationStepper from "./registrationStepper";
import { useRouter } from "next/router";
function NavbarBigScreen({
  activeStep,
  showDivider
}) {
  const {
    t
  } = useTranslation();
  const [scrollDown, setScrollDown] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(0);
  const router = useRouter();
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > prevScrollY) {
        setScrollDown(true);
      } else {
        setScrollDown(false);
      }
      setPrevScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <>
      <div className={`${classes.navHead} ${scrollDown ? classes.boxShadow : classes.boxShadowNone}`}>
        <div className={classes.container}>
          <div className={classes.navHeaderContainer}>
            <div className={classes.headerContainer}>
              <div className={`${classes.nav_logo}`}>
                <Image src={applogo} alt={t("utsav-logo")} priority objectFit="cover" data-sentry-element="Image" data-sentry-source-file="navbarBigScreen.jsx" />
              </div>

              <Typography className={classes.logoText} data-sentry-element="Typography" data-sentry-source-file="navbarBigScreen.jsx">{t("utsav")}</Typography>
            </div>
          </div>
          <div className={classes.navStepper}>
            <RegistrationStepper activeStep={activeStep} showDivider={showDivider} bigScreen={true} data-sentry-element="RegistrationStepper" data-sentry-source-file="navbarBigScreen.jsx" />
          </div>
          <LangugageDropdown data-sentry-element="LangugageDropdown" data-sentry-source-file="navbarBigScreen.jsx" />
        </div>
      </div>
    </>;
}
export default NavbarBigScreen;